"use client";
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import {
  Col,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Switch,
  Tooltip,
  Typography,
} from "antd";
import dayjs from "dayjs";
import { BOM } from "../../../../../services/definedMethod";
import { labelConfig } from "../../wallet.config";

const { Text } = Typography;

const AccountParametersForm = (props) => {
  const {
    onFinish,
    form,
    initialValues,
    statementCycleOptions,
    checkedInterestBearing,
    setCheckedInterestBearing,
    selectedCurrencySymbol,
    isDormancyTrackingActive,
    setIsDormancyTrackingActive,
  } = props;

  const handleInterestBearingChange = (checked) => {
    setCheckedInterestBearing(checked);
    if (!checked) {
      // Clear interest-only fields so a stale/hidden value is never submitted
      form.setFieldsValue({
        nominalAnnualInterestRate: undefined,
        minBalanceForInterestCalculation: undefined,
      });
    }
  };

  const handleDormancyTrackingChange = (checked) => {
    setIsDormancyTrackingActive(checked);
  };

  const today = dayjs();

  return (
    <div>
      <h1 style={{ fontSize: "24px", fontWeight: "bold", margin: 0 }}>
        Account Parameters
      </h1>
      <p
        style={{
          color: "#6b7280",
          fontWeight: "400",
          marginBottom: "24px",
          marginTop: 0,
        }}
      >
        Add description text to note for users
      </p>

      <Form
        className="custom-form"
        layout="vertical"
        onFinish={onFinish}
        form={form}
        initialValues={initialValues}
        style={{ width: "100%" }}
      >
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<span>Maximum Wallet Balance</span>}
              name="maximumWalletBalance"
              rules={[
                {
                  required: true,
                  message: "Maximum Wallet Balance is required",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%", height: 44 }}
                className="bond-input"
                placeholder="e.g., 500,000.00"
                prefix={selectedCurrencySymbol}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<span>Daily Transaction Limit</span>}
              name="dailyTransactionLimit"
              rules={[
                {
                  required: true,
                  message: "Daily Transaction Limit is required",
                },
              ]}
            >
              <InputNumber
                style={{ width: "100%", height: 44 }}
                // className="bond-input"
                placeholder="e.g., 500,000.00"
                prefix={selectedCurrencySymbol}
                formatter={BOM.FormatAmount}
                parser={BOM.ParseAmount}
              />
            </Form.Item>
          </Col>
        </Row>{" "}
        <Row>
          <Col span={12} style={{ padding: "0px 8px 14px 8px" }}>
            <Row
              style={{
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <div>
                <Switch
                  checked={isDormancyTrackingActive}
                  onChange={handleDormancyTrackingChange}
                  style={{
                    backgroundColor: isDormancyTrackingActive
                      ? "#b026ff"
                      : "#F2F4F7",
                  }}
                />
                <Text style={{ marginLeft: 10, marginRight: 10 }}>
                  Enable Dormancy Tracking
                </Text>
              </div>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={12} style={{ padding: "0px 8px 14px 8px" }}>
            <Row
              style={{
                alignItems: "center",
                justifyContent: "space-between",
                gap: 10,
              }}
            >
              <div>
                <Switch
                  checked={checkedInterestBearing}
                  onChange={handleInterestBearingChange}
                  style={{
                    backgroundColor: checkedInterestBearing
                      ? "#b026ff"
                      : "#F2F4F7",
                  }}
                />
                <Text style={{ marginLeft: 10, marginRight: 10 }}>
                  Interest Bearing
                </Text>
              </div>
            </Row>
          </Col>
        </Row>
        <div hidden={checkedInterestBearing ? false : true}>
          <Row>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<span>Minimum Balance for Interest</span>}
                name="minBalanceForInterestCalculation"
                rules={[
                  {
                    required: checkedInterestBearing,
                    message: "Minimum Balance for Interest is required",
                  },
                ]}
              >
                <InputNumber
                  style={{ width: "100%", height: 44 }}
                  className="bond-input"
                  placeholder="e.g., 500,000.00"
                  prefix={selectedCurrencySymbol}
                  formatter={BOM.FormatAmount}
                  parser={BOM.ParseAmount}
                />
              </Form.Item>
            </Col>
            <Col span={12} style={{ padding: "0px 8px" }}>
              <Form.Item
                label={<span>Interest Rate</span>}
                name="nominalAnnualInterestRate"
                rules={[
                  {
                    required: checkedInterestBearing,
                    message: "Interest Rate is required",
                  },
                  {
                    type: "number",
                    min: 0,
                    max: 100,
                    message: "Interest Rate must be between 0 and 100",
                  },
                ]}
              >
                <InputNumber
                  className="interestRate-input"
                  style={{ width: "100%", height: 44 }}
                  placeholder="Please enter an interest rate"
                  suffix={"%"}
                  min={0}
                  max={100}
                  step={0.01}
                  precision={2}
                />
              </Form.Item>
            </Col>
          </Row>
        </div>
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={<span>Lock-in Period</span>}
              // label={<span>Minimum Period for Interest</span>}
              name="lockinPeriodFrequency"
              rules={[
                {
                  type: "number",
                  min: 0,
                  message: "Lock-in Period cannot be negative",
                  transform: (value) =>
                    value === "" || value === undefined || value === null
                      ? undefined
                      : Number(value),
                },
              ]}
            >
              <Input
                className="bond-input"
                style={{ height: 44 }}
                placeholder="Please enter the Minimum Period for Interest"
                type="number"
                min={0}
                suffix="Days"
              />
            </Form.Item>
          </Col>

          {isDormancyTrackingActive && (
            <>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={<span>Dormancy Period</span>}
                  name="daysToDormancy"
                  rules={[
                    {
                      required: true,
                      message: "Dormancy Period is required",
                    },
                  ]}
                >
                  <Input
                    className="bond-input"
                    style={{ height: 44 }}
                    placeholder="Please enter the Dormancy Period"
                    type="number"
                    suffix="Days"
                  />
                </Form.Item>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <span>
                      {BOM.SubstringFormat(
                        labelConfig.numberOfDaysToInactiveSubStatus,
                        20,
                      )}
                      <Tooltip
                        title={labelConfig.numberOfDaysToInactiveSubStatus}
                      >
                        <InfoCircleOutlined
                          style={{
                            marginLeft: "4px",
                            color: "#667085",
                          }}
                        />
                      </Tooltip>
                    </span>
                  }
                  name={"daysToInactive"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld(
                        "Number of Days to Inactive Sub-status",
                      ),
                    },
                  ]}
                >
                  <Input
                    className="bond-input"
                    style={{ height: 44 }}
                    placeholder="Please enter the Dormancy Period"
                    type="number"
                    suffix="Days"
                  />
                </Form.Item>
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Form.Item
                  label={
                    <span>
                      {BOM.SubstringFormat(
                        labelConfig.numberOfDaysToEscheat,
                        20,
                      )}
                      <Tooltip title={labelConfig.numberOfDaysToEscheat}>
                        <InfoCircleOutlined
                          style={{
                            marginLeft: "4px",
                            color: "#667085",
                          }}
                        />
                      </Tooltip>
                    </span>
                  }
                  name={"daysToEscheat"}
                  rules={[
                    {
                      required: true,
                      message: BOM.CheckReqFld("Number of Days to Escheat"),
                    },
                  ]}
                >
                  <Input
                    className="bond-input"
                    style={{ height: 44 }}
                    placeholder="Please enter the Dormancy Period"
                    type="number"
                    suffix="Days"
                  />
                </Form.Item>
              </Col>
            </>
          )}
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              label={
                <span>
                  Statement Cycle
                  <Tooltip title="Select the Statement Cycle">
                    <InfoCircleOutlined
                      style={{
                        marginLeft: "4px",
                        color: "#667085",
                      }}
                    />
                  </Tooltip>
                </span>
              }
              name="statementCycle"
              rules={[
                {
                  required: true,
                  message: "Please select the Statement Cycle",
                },
              ]}
            >
              <Select
                placeholder="Please select the Statement Cycle"
                style={{ height: 44 }}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
                options={statementCycleOptions}
                mode="multiple"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default AccountParametersForm;
